import React from 'react';
import { Row, Col } from 'reactstrap';

import CircularTooltip from './CircularTooltip';
import App_data from '../../../config/App_data';

function VideoFooter({
  rowClassName = '',
  showFreePremium = true,
  moveToNotes,
  moveToPracticeQuestion,
  saveVideo,
  toggleReportSection,
  onViewPDF,
  videoId,
  isVideoSaved,
  pdfFile,
  checkSubscription,
}) {
  return (
    <Row className={rowClassName}>
      <Col xs='12' md='6' className='d-flex'>
        <CircularTooltip tooltipContent={'Go to Notes'} className='pl-0'>
          <i
            onClick={() => checkSubscription(moveToNotes)}
            className='fa fa-book mark-action-btn'
            style={{ color: '#1f8ceb' }}
          />
        </CircularTooltip>

        <CircularTooltip tooltipContent={'Go to Question Bank'}>
          <i
            onClick={moveToPracticeQuestion}
            className='fa fa-question-circle-o mark-action-btn'
            style={{ color: '#1d364b' }}
          />
        </CircularTooltip>
        <CircularTooltip tooltipContent={'Save this item on your dashboard for further review.'}>
          <i
            onClick={() => saveVideo(videoId)}
            className={
              isVideoSaved
                ? 'fa fa-bookmark mark-action-btn-bookmark'
                : 'fa fa-bookmark-o mark-action-btn-bookmark'
            }
            style={{ color: isVideoSaved ? 'rgb(54, 141, 84)' : '#1d364b' }}
          />
        </CircularTooltip>

        <CircularTooltip tooltipContent={"Report this video to AnalystPrep's team for review."}>
          {/* <i
            onClick={toggleReportSection}
            className='fa fa-exclamation-triangle mark-action-btn'
            style={{ color: '#ef2100' }}
          /> */}
          <span className='mark-action-btn'>
            <img
              src={App_data.frontend_url + '/img/report4.png'}
              alt='report'
              onClick={toggleReportSection}
              className=''
              style={{ color: '#ef2100' }}
            />
          </span>
        </CircularTooltip>
      </Col>
      {pdfFile ? (
        <Col xs='12' md='6' className='padding-10px'>
          <div className='status-download-btn'>
            <a
              className='btn btn-primary  pointer_class pull-right'
              onClick={() => checkSubscription(onViewPDF)}
            >
              <i className='fa fa-download  ' aria-hidden='true' />
              {showFreePremium ? <div className='premium-download'>Premium</div> : null}
              View PDF
            </a>
          </div>
        </Col>
      ) : null}
    </Row>
  );
}

export default VideoFooter;



// WEBPACK FOOTER //
// ./src/views/SOA/Probability/VideoDisplay/VideoFooter.jsx